<div class="grid grid-nogutter flex justify-content-start align-items-center width-100 pl-3" style="gap: 10px">
  <div class="col-fixed">
    <app-thumbnail
      (click)="navigateTo(item)"
      [imgSrc]="item.author.avatar | mediaObject"
      [circle]="true"
      size="lg"
    >
    </app-thumbnail>
  </div>
  <div class="col-6" style="min-width: 200px">
    <div>
      <a (click)="navigateTo(item)">{{ item.author.username }}</a>
    </div>
    <span *ngIf="item | projectUserCount: currentUser as projectUserCount">
      <ng-container *ngIf="projectUserCount.hasUser || projectUserCount.projectCount">
        {{ 'common.reactions.user_projects' | translate: {
          user: projectUserCount.hasUser ? (projectUserCount.userTranslateParam | lowercase) : '',
          project: projectUserCount.projectTranslateParam | translateSelector: projectUserCount.projectCount,
          and: projectUserCount.hasUser && projectUserCount.projectCount ? ('common.and' | translate) : ''
        } }}
      </ng-container>
    </span>

    <ng-container *ngIf="item.reactedTo | filterCollectionByType: 'Project' as reactedProjects">
      <div *ngIf="reactedProjects.length > 1" class="width-100">
        <swiper [config]="swiperConfig">
          <ng-template swiperSlide *ngFor="let reacted of reactedProjects">
            <div>
              <app-thumbnail
                [imgSrc]="reacted.avatar | mediaObject"
                [circle]="true"
                size="md"
              >
              </app-thumbnail>
            </div>
          </ng-template>
        </swiper>
      </div>

      <div *ngIf="reactedProjects.length === 1" class="flex align-items-center mb-2">
        <app-thumbnail
          [imgSrc]="reactedProjects[0].avatar | mediaObject"
          [circle]="true"
          size="md"
        >
        </app-thumbnail>
      </div>
    </ng-container>

    <div *ngIf="showReactionIntent && item.reactedTo.length === 1" class="flex align-items-center">
      <ngx-emoji [emoji]="item.reactedWith[0] | reactionClassMap" size="20"></ngx-emoji>
      <span class="ml-2">
        {{ ('common.reaction.' + item.reactedWith[0].toLowerCase()) | translate | translateSelector: item.author['@id'] === currentUser['@id'] ? 'c' : 'o' }}
      </span>
    </div>
  </div>
  <div class="col-fixed flex ml-auto gap-2 relative w-3rem h-3rem" *ngIf="item.author?.slug && !item.author?.deleted">
    <app-item-action-dial
      [isFollowedByCurrentUser]="isFollowedByCurrentUser()"
      [isReactedByCurrentUser]="isLikedByCurrentUser()"
      [subjectUserVM]="item.author"
      [currentUserVM]="currentUser"
    ></app-item-action-dial>
  </div>
</div>
